import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../shared/shared.module';
import { ButtonModule, DialogConfig, DialogRef } from '@sag-ui';

@Component({
    selector: 'app-cancel-application-dialog',
    standalone: true,
    imports: [CommonModule, ButtonModule, SharedModule],
    templateUrl: './cancel-application.component.html'
})
export class CancelCodCreationDialogComponent {
    constructor(public config: DialogConfig, public dialogRef: DialogRef<string>) {}

    public onClose(result?: string): void {
        this.dialogRef.close(result);
    }
}
